/**
 * Pricing configuration
 * Single source of truth for all pricing across the application
 */

export function getPricingProducts() {
  return {
    basic: {
      id: "basic",
      name: "Basic",
      pricing: {
        monthly: {
          base: 5.720799737080895, // Produces €5/month for Germany, adjusted by country
          credit: 2.8603998685404477, // 50% of base allocated as AI credits
        },
        yearly: {
          base: 57.207997370808954, // Produces €50/year for Germany, adjusted by country
          credit: 28.603998685404477, // 50% of base allocated as AI credits
        },
      },
      features: [
        { icon: "check_circle", text: "AI agent credit included", dynamic: true },
        {
          icon: "check_circle",
          text: "Credit expires at end of billing period",
        },
        { icon: "check_circle", text: "Pay-as-you-go after credits run out" },
        {
          icon: "check_circle",
          text: "<b>Support the Counterpunch editor development</b>",
        },
      ],
      buttonText: "Subscribe",
      buttonAction: "startSubscription",
      buttonClass: "pricing-button-primary",
    },
  };
}
